export const validateResponse = (responseJSON) => (
  !!(responseJSON &&
    responseJSON.payload &&
    responseJSON.payload.id &&
    responseJSON.payload.bundleType &&
    responseJSON.payload.recommendationType &&
    responseJSON.payload.attachments &&
    Array.isArray(responseJSON.payload.attachments) &&
    responseJSON.payload.attachments.length)
);

export const fetchAttachments = async (storeUrl, mainProductId, visitorId = 0) => {
  const response = await fetch(
    // eslint-disable-next-line max-len
    `${storeUrl}/products/${mainProductId}/popup_style_attach/visitors/${visitorId}?filters=allAttachments`,
    { credentials: 'same-origin' }
  );
  const responseJSON = await response.json();
  if (validateResponse(responseJSON)) {
    return {
      recommendationType: responseJSON.payload.recommendationType,
      bundleType: responseJSON.payload.bundleType,
      productID: responseJSON.payload.id,
      attachments: responseJSON.payload.attachments
    };
  }
  throw new Error('Invalid data received from PSA endpoint.');
};
